import { inject } from 'vue';
/** @internal */
export const appIdSymbol = Symbol.for('zsc-vite-plugin-ssr: appId');
/**
 * The appId plugin provides information about the current app's mounting ID
 * and is automatically installed by zsc-plugin-vite-ssr
 *
 * @internal
 */
export function appIdPlugin(appId) {
    return {
        install(app) {
            app.config.globalProperties.$appId = appId;
            app.provide(appIdSymbol, appId);
        },
    };
}
/**
 * Returns the mounting ID of the current app
 */
export function useAppId() {
    return inject(appIdSymbol);
}
//# sourceMappingURL=app-id.js.map